import { Routes } from '@angular/router';
import { LayoutComponent } from './shared/layout/layout.component';
import { LayoutBlankComponent } from './shared/layout-blank/layout-blank.component';
import { LayoutUserComponent } from './shared/layout-user/layout-user.component';
import { AuthGuard } from './shared/guards/auth.guard';
import { DevAccessGuard } from './shared/guards/dev-access.guard';
import { TestComponent } from './admin/admin-forms/test-component';

export const routes: Routes = [
    // Redirect empty path to '/example'
    { path: '', pathMatch: 'full', redirectTo: 'inicio' },
    
    // *** RUTA TEMPORAL PARA TEST - ELIMINAR DESPUÉS ***
    { path: 'test-form', component: TestComponent },
    
    
    // sin layout - rutas públicas
    {
        path: '',
        canActivate: [DevAccessGuard],
        children: [
            { path: 'qr/:qr', loadChildren: () => import('./users/qr/qr.routes') },
            { path: 'registro-qr', loadChildren: () => import('./users/opportunity-form-qr/opportunity-form-qr.routes') },
            { path: 'referentes', loadChildren: () => import('./users/referentes/referentes.routes') },
            { path: 'inscripciones-cantera', loadChildren: () => import('./admin/cantera/formulario/formulario.routes') },
            { path: 'formulario/:id', loadChildren: () => import('./admin/admin-forms/public/public-form.routes') },
            { path: 'inscripciones-referentes', loadChildren: () => import('./users/referentes/formulario-referentes/formulario-referentes.routes') },
            { path: 'buscamoslideres', loadChildren: () => import('./users/buscamoslideres/buscamoslideres.routes') },
            { path: 'festival-oportunidades', loadChildren: () => import('./users/festival-oportunidades/festival-oportunidades.routes') },
            { path: 'empleo-fest', loadChildren: () => import('./users/empleo-fest/empleo-fest.routes') },
            { path: 'formulario-empleo-fest', loadChildren: () => import('./users/formulario-empleo-fest/formulario-empleo-fest.routes') },

        ]
    },

    // sin layout - rutas con autenticación
    {
        path: '',
        canActivate: [AuthGuard, DevAccessGuard],
        canActivateChild: [AuthGuard],
        children: [
            { path: 'reserva-epg', loadChildren: () => import('./users/epm/reserva-epm/reserva-epm.routes') },

        ]
    },
    // a esta ruta no se le aplica el DevAccessGuard porque es la ruta de login para desarrolladores, 
    // que es necesaria incluso cuando DevAccess está habilitado. 
    // Si se aplicara el guard aquí, los desarrolladores no podrían acceder a 
    // la página de login para obtener su token de desarrollo.
    {
        path: '',
        component: LayoutBlankComponent,
        children: [
            { path: 'dev-login', loadChildren: () => import('./users/dev-login/dev-login.routes') }, 
        ]
    },
    // Auth routes for guests
    {
        path: '',
        canActivate: [DevAccessGuard],
        // canActivateChild: [NoAuthGuard],
        component: LayoutBlankComponent,
        children: [
            { path: 'verificar-cuenta', loadChildren: () => import('./auth/confirmation-required/confirmation-required.routes') },
            { path: 'recuperar-cuenta', loadChildren: () => import('./auth/forgot-password/forgot-password.routes') },
            { path: 'reset-password/:email/:token', loadChildren: () => import('./auth/reset-password/reset-password.routes') },
            { path: 'activar-cuenta/:email/:token', loadChildren: () => import('./auth/activar-cuenta/activar-cuenta.routes') },
            { path: 'iniciar-sesion', loadChildren: () => import('./auth/login/login.routes') },
            { path: 'inscribirse', loadChildren: () => import('./auth/sign-up/sign-up.routes') },
            { path: 'usuario-invitado/:token', loadChildren: () => import('./users/invite-user/invite-user.component.routes') },
            { path: 'desparchadero', loadChildren: () => import('./users/salvavidas/salvavidas.routes') },
            { path: 'que-hay-pa-hacer', loadChildren: () => import('./users/plans-events/plans-events.routes') },
            { path: 'que-hay-pa-hacer/:link', loadChildren: () => import('./users/plans-events/plans-events.routes') },
            { path: 'que-hay-pa-hacer/:link/:video', loadChildren: () => import('./users/plans-events/plans-events.routes') },
            { path: 'crm/accept-terms', loadChildren: () => import('./admin/organizations/accept-terms/accept-terms.routes').then(m => m.ACCEPT_TERMS_ROUTES) },
            { path: 'crm/terms-accepted', loadChildren: () => import('./admin/organizations/terms-accepted/terms-accepted.routes').then(m => m.TERMS_ACCEPTED_ROUTES) },
            { path: 'formularios/invitacion', loadChildren: () => import('./admin/admin-forms/invitation/form-invitation.routes') },
            { path: 'jovenespropietarios', loadChildren: () => import('./users/jovenes-propietarios/jovenes-propietarios.routes') },
            { path: 'jovenespropietarios-aprendizaje', loadChildren: () => import('./users/jovenes-propietarios/aprendizaje/aprendizaje.routes') },
            // { path: 'semana-registro', loadChildren: () => import('./users/semanaJuventud/cierre-form/cierre-form.routes') },
            { path: 'semana', loadChildren: () => import('./users/semanaJuventud/inicio/inicio.routes') },

        ]
    },
    {
        path: '',
        canActivate: [AuthGuard, DevAccessGuard],
        canActivateChild: [AuthGuard],
        component: LayoutBlankComponent,
        children: [
            { path: 'formularios/invitacion', loadChildren: () => import('./admin/admin-forms/invitation/form-invitation.routes') },

        ]
    },

    // Auth routes for authenticated users
    {
        path: '',
        canActivate: [DevAccessGuard],
        // canActivateChild: [AuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
            // {path: 'sign-out', loadChildren: () => import('app/modules/auth/sign-out/sign-out.routes')},
            // {path: 'unlock-session', loadChildren: () => import('app/modules/auth/unlock-session/unlock-session.routes')}
        ]
    },

    // Landing routes
    {
        path: '',
        canActivate: [AuthGuard, DevAccessGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'classic'
        },
        children: [
            { path: 'inicio-administrador', loadChildren: () => import('./admin/home-admin/home-admin.routes') },
            { path: 'nueva-oportunidad', loadChildren: () => import('./admin/nueva-oportunidad/nueva-oportunidad.routes') },
            { path: 'nueva-formacion', loadChildren: () => import('./admin/new-training/new-training.routes') },
            { path: 'nuevo-plan-evento', loadChildren: () => import('./admin/new-plans-events/new-plans-events.routes') },
            { path: 'admin-musiclab', loadChildren: () => import('./admin/musiclab/musiclab.routes') },
            { path: 'admin-musiclab-artistas', loadChildren: () => import('./admin/musiclab-artists/musiclab-artists.routes') },
            { path: 'admin-musiclab-votos', loadChildren: () => import('./admin/musiclab-artists-votes/musiclab-artists-votes.routes') },
            { path: 'admin-mj-evento-music-lab', loadChildren: () => import('./admin/music-lab-event/create-event/create-event.routes') },
            { path: 'organizaciones', loadChildren: () => import('./admin/organizations/organizations.routes') },
            { path: 'seccion-herramientas', loadChildren: () => import('./admin/tools-section/tools-section.routes') },
            { path: 'ofertas-destacadas', loadChildren: () => import('./admin/featured-offers/featured-offers.routes') },
            { path: 'evento-oportunidades', loadChildren: () => import('./admin/opportunity-event/opportunity-event.routes') },
            { path: 'admin-banner-parches', loadChildren: () => import('./admin/banner-events-plans/banner-events-plans.routes') },
            { path: 'admin-banner-formacion', loadChildren: () => import('./admin/banner-training/banner-training.routes') },
            { path: 'admin-banner-home', loadChildren: () => import('./admin/banner-home/banner-home.routes') },
            { path: 'admin-banner-empleo', loadChildren: () => import('./admin/banner-opportunity/banner-opportunity.routes') },
            { path: 'admin-sesiones-usario', loadChildren: () => import('./admin/session-player/session-player.routes') },
            { path: 'admin-mj-recorridos', loadChildren: () => import('./admin/callejeros/recorridos/recorridos.routes') },
            { path: 'admin-mj-registrados-recorridos', loadChildren: () => import('./admin/callejeros/registrados/registrados.routes') },
            { path: 'testimonios', loadChildren: () => import('./admin/testimonies/testimonies.routes') },
            { path: 'admin-servicios', loadChildren: () => import('./admin/opportunity-services/opportunity-services.routes') },
            { path: 'admin-banner-servicios', loadChildren: () => import('./admin/banner-service/banner-service.routes') },
            { path: 'admin-cedezos', loadChildren: () => import('./admin/cedezos/cedezos.routes') },
            { path: 'admin-parceros-carga', loadChildren: () => import('./admin/parceros/carga/carga.routes') },
            { path: 'admin-parceros-mapa', loadChildren: () => import('./admin/parceros/mapa/mapa.routes') },
            { path: 'estadisticas', loadChildren: () => import('./admin/analytics/analytics.routes') },
            { path: 'admin-creadores', loadChildren: () => import('./admin/creadores-admin/creadores-admin.routes') },
            { path: 'admin-semana', loadChildren: () => import('./admin/semana-admin/semana-admin.routes') },
            { path: 'admin-mj-cartilla-empleo-codigo', loadChildren: () => import('./admin/cartilla/codigo/codigo.routes') },
            { path: 'admin-mj-cartilla-empleo-registrados', loadChildren: () => import('./admin/cartilla/registrados/registrados.routes') },
            { path: 'admin-mj-micrositio-semana', loadChildren: () => import('./admin/semana-admin/admin-micrositio/admin-micrositio.routes') },
            { path: 'admin-mj-semana-secciones', loadChildren: () => import('./admin/semanaJuventud/secciones/secciones.routes') },
            { path: 'admin-editar-usuarios', loadChildren: () => import('./admin/semanaJuventud/registros/registros.routes') },
            { path: 'admin-mj-semana-ingreso', loadChildren: () => import('./admin/semanaJuventud/ingreso/ingreso.routes') },
            { path: 'admin-mj-semana-estadisticas', loadChildren: () => import('./admin/semanaJuventud/estadisticas/estadisticas.routes') },
            { path: 'admin-mj-evento', loadChildren: () => import('./admin/opportunity-festival/create-event/create-event.routes') },
            { path: 'admin-mj-attendance-control', loadChildren: () => import('./admin/opportunity-festival/attendance-control/attendance-control.routes') },
            { path: 'admin-mj-report', loadChildren: () => import('./admin/opportunity-festival/report/report.routes') },
            { path: 'admin-popup-banner', loadChildren: () => import('./admin/popup-banners/popup-banners.routes') },
            { path: 'admin-error-logs', loadChildren: () => import('./admin/error-logs/error-logs.routes') },
            { path: 'admin-organization', loadChildren: () => import('./admin/opportunity-festival/admin-organization/admin-organization.routes') },
            { path: 'admin-referentes-noticia', loadChildren: () => import('./admin/referentes/noticia/noticia.routes') },
            { path: 'admin-referentes-galeria', loadChildren: () => import('./admin/referentes/galeria/galeria.routes') },


            { path: 'admin-banner-observatorio', loadChildren: () => import('./admin/banner-observatorio/banner-observatorio.routes') },
            { path: 'admin-observatorio', loadChildren: () => import('./admin/admin-observatorio/admin-observatorio.routes') },
            { path: 'evento-music-lab', loadChildren: () => import('./admin/music-lab-event/music-lab-event.routes') },
            { path: 'admin-salvavidas', loadChildren: () => import('./admin/admin-salvavidas/admin-salvavidas.routes') },
            { path: 'admin-usuarios', loadChildren: () => import('./admin/admin-users/admin-users.routes') },
            { path: 'admin-salvavidas-aprende-explora', loadChildren: () => import('./admin/admin-salvavidas/admin-sitios-interes/admin-sitios-interes.routes') },
            { path: 'evento-cantera', loadChildren: () => import('./admin/cantera/create-event/create-event.routes') },
            { path: 'registrados-cantera', loadChildren: () => import('./admin/cantera/cantera.routes') },
            { path: 'builder-formularios', loadChildren: () => import('./admin/admin-forms/builder/builder.routes') },
            { path: 'respuestas-formularios/:id', loadChildren: () => import('./admin/admin-forms/submissions/form-submissions.routes') },
            { path: 'admin-epg-sesiones', loadChildren: () => import('./admin/epm/sesiones/sesiones.routes') },
            { path: 'admin-epg-sanciones', loadChildren: () => import('./admin/epm/sanciones/sanciones.routes') },
            { path: 'admin-epg-config', loadChildren: () => import('./admin/epm/config/config.routes') },
            { path: 'evento-referentes', loadChildren: () => import('./admin/referentes/evento-referentes/evento-referentes.routes') },
            { path: 'registrados-referentes', loadChildren: () => import('./admin/referentes/registrados-referentes/registrados-referentes.routes') },
            { path: 'admin-jp-constructoras', loadChildren: () => import('./admin/admin-jovenes-propietarios/constructoras/constructoras.routes') },
            { path: 'admin-jp-zonas', loadChildren: () => import('./admin/admin-jovenes-propietarios/zonas/zonas.routes') },
            { path: 'admin-jp-proyectos', loadChildren: () => import('./admin/admin-jovenes-propietarios/proyectos/proyectos.routes') },
            { path: 'admin-jp-documentos', loadChildren: () => import('./admin/admin-jovenes-propietarios/documentos/documentos.routes') },
            { path: 'admin-jp-postulaciones', loadChildren: () => import('./admin/admin-jovenes-propietarios/postulaciones/postulaciones.routes') },
            { path: 'admin-catalogo-documentos', loadChildren: () => import('./admin/parcero-documento/catalogo-documentos/catalogo-documentos.routes') },
            { path: 'admin-gestion-mentores', loadChildren: () => import('./admin/parcero-documento/gestion-mentores/gestion-mentores.routes') },
            { path: 'admin-joven-parcero', loadChildren: () => import('./admin/parcero-documento/joven-parcero/joven-parcero.routes') },
            { path: 'admin-dashboard', loadChildren: () => import('./admin/parcero-documento/dashboard/dashboard.routes') },
            { path: 'admin-mis-jovenes', loadChildren: () => import('./admin/parcero-documento/mis-jovenes/mis-jovenes.routes') },
            { path: 'admin-auditoria', loadChildren: () => import('./admin/parcero-documento/auditoria/auditoria.routes') },
            { path: 'admin-mis-documentos', loadChildren: () => import('./admin/parcero-documento/mis-documentos/mis-documentos.routes') },

        ]
    },

    // user
    {
        path: '',
        canActivate: [DevAccessGuard],
        // canActivateChild: [AuthGuard],
        component: LayoutUserComponent,
        children: [
            { path: 'inicio', loadChildren: () => import('./users/home-user/home-user.routes') },
            { path: 'empleo', loadChildren: () => import('./users/opportunities/opportunities.routes') },
            { path: 'empleo/:link', loadChildren: () => import('./users/opportunities/opportunities.routes') },
            { path: 'formacion', loadChildren: () => import('./users/training/training.routes') },
            { path: 'formacion/:link', loadChildren: () => import('./users/training/training.routes') },
            { path: 'politicas', loadChildren: () => import('./shared/politicas/politicas.routes') },
            { path: 'servicios', loadChildren: () => import('./users/opportunity-services/opportunity-services.routes') },
            { path: 'servicios/:link', loadChildren: () => import('./users/opportunity-services/opportunity-services.routes') },
            { path: 'observatorio', loadChildren: () => import('./users/observatorio/observatorio.routes') },
            { path: 'observatorio/:link', loadChildren: () => import('./users/observatorio/observatorio.routes') },
            


        ]
    },
    // user AHUTH
    {
        path: '',
        canActivate: [AuthGuard, DevAccessGuard],
        canActivateChild: [AuthGuard],
        component: LayoutUserComponent,
        children: [
            { path: 'perfil', loadChildren: () => import('./users/profile/profile.routes') },

        ]
    },


    { path: '**', redirectTo: '/' }
];
